module.exports = __webpack_public_path__ + "ipetbooking/admin/img/daycare.b2e8829a.svg";